const getters = {
  sidebar: state => state.app.sidebar,
  size: state => state.app.size,
  device: state => state.app.device,
  visitedViews: state => state.tagsView.visitedViews,
  cachedViews: state => state.tagsView.cachedViews,
  token: state => state.user.token,
  avatar: state => state.user.avatar,
  name: state => state.user.name,
  introduction: state => state.user.introduction,
  roles: state => state.user.roles,
  authority: state => state.user.authority,
  permission_routes: state => state.permission.routes,
  routesAdded: state => state.permission.routesAdded,
  errorLogs: state => state.errorLog.logs,
  user: state => state.user.user,
  assistVisible: state => state.user.assistVisible,
  // 可选月份（到最新一张凭证录证月份）,账簿与核对总账等模块需要，这是一个promise对象
  selectableMonth: state => state.user.selectableMonth,
  // 可选月份（到当前系统时间）,日记账需要，这是一个promise方法
  selectableMonthToNow: state => state.user.selectableMonthToNow,
  // 获取登录选择的月份，账簿与核对总账模块需要
  loginMonth: ({ user }) => {
    const loginData = user.loginDate;
    const month = loginData.getFullYear() + '-' +
      (loginData.getMonth() + 1 < 10 ? '0' : '') +
      (loginData.getMonth() + 1);
    return month;
  },
  // 获取登录选择的季度，利润表需要
  loginSeason: ({ user }) => {
    const loginData = user.loginDate;
    const season = loginData.getFullYear() + '-0' + (Math.ceil((loginData.getMonth() + 1) / 3));
    return season;
  }
}
export default getters
